import React from 'react'

import { RECAPTCHA_AHORROYA_INVISIBLE_KEY } from '../../constants/URLs'
import { isBrowser } from '../../components/pagesPartials/formularios/isBrowser'

import {
  RadCheck,
  SelectAhorroYa,
  TextInput,
} from '../../components/forms/forms'
import Btn from '../../components/buttons/buttons'
import {
  validateDniInput,
  validateCarnetInpu,
} from '../../lib/customValidation'
import {
  CODES_RESPONSE,
  serviceRequest as ahorroyaApi,
  SERVICE_AFFILIATE,
  SERVICE_VALIDATION,
  SERVICE_OTP_VALIDATION,
  SERVICE_OTP_GENERATION,
} from '../../api/ahorro-ya'
import '../aliados-comerciales/sobre-el-programa/sobre-el-programa.css'
import './registrate-aqui.css'
import ReCAPTCHA from 'react-google-recaptcha'
import { SpinnerImage } from '../../components/spinner/spinner'
import Input from '../productos/cuenta-metas/input'
import {
  IcoStepsOne,
  IcoStepsTwo,
  IcoStepsCheck,
  IconSmsOption,
  IconEmailOption,
  Aprobed,
  WarningOtp,
  IcoStepsTwoDisabled,
  ValidToken,
  NoValidToken,
  Clock,
} from '../../lib/svg'
import { GTMEvents } from '../../lib/GTMevents'
import { withPrefix } from 'gatsby'
import HeadersSteps from '../../components/aliados-comerciales/sobre-el-programa/registro-ahorroya-steps/headersSteps'
import Step4 from '../../components/aliados-comerciales/sobre-el-programa/registro-ahorroya-steps/step4'

class RegistrateAqui extends React.Component {
  state = {
    userCaptchaAttemp_reg: '',
    documentType: '00',
    document: '',
    checkOne: 'N',
    checkTwo: 'N',
    response: {},
    responseOtp: {},
    newResponseValidate: {},
    showContent: false,
    loading: false,
    documentLength: false,
    withRegister: false,
    step: 1,
    numbers: '',
    inputRefs: [],
    tokenValidate: '',
    validateOption: 0,
    emailInvalid: false,
    emailNull: false,
    validateNumbers: 0,
    restTime: 300,
  }

  captcha = React.createRef()

  componentDidMount() {
    isBrowser()
  }

  onVerify = token => this.setState({ userCaptchaAttemp_reg: token })

  onExpired = () => this.setState({ userCaptchaAttemp_reg: '' })

  handleDocumentType = val => {
    this.setState({
      loading: false,
      response: {},
      showContent: false,
      document: '',
    })
    val === 'DNI'
      ? this.setState({ documentType: '00' })
      : this.setState({ documentType: '01' })
  }

  handleCheckOne = val => {
    if (val === 'N') {
      GTMEvents.AhorroYaTermAndConditionBtn(`Acepto los terminos y condiciones`)
    }
    val === 'N'
      ? this.setState({ checkOne: 'S' })
      : this.setState({ checkOne: 'N' })
  }

  fetchValidationDocument = async e => {
    try {
      const { documentType } = this.state
      const expectedLength = documentType == '00' ? 8 : 9
      const validationFunction =
        documentType == '00' ? validateDniInput : validateCarnetInpu
      const documentNumber = validationFunction(e.target.value)

      this.setState({ document: documentNumber })

      if (e.target.value.length === expectedLength) {
        this.captcha.current.reset()
        const token = await this.captcha.current.executeAsync()

        this.setState({
          loading: true,
          showContent: false,
          userCaptchaAttemp_reg: token,
        })
        const response = await ahorroyaApi(
          'GET',
          `${SERVICE_AFFILIATE}${SERVICE_VALIDATION}/documentType/${documentType}/documentNumber/${documentNumber}`,
          {},
          token
        )
        this.setState({
          loading: false,
          response: response,
          checkOne: 'N',
          checkTwo: 'N',
          showContent: true,
          documentLength: true,
        })
        if (response.code == 'NCL-SR-001') {
          GTMEvents.AhorroYaIsAfilliateMessage()
        }
        if (response.email == null) {
          this.setState({ emailNull: true })
        }
      } else {
        this.setState({
          loading: false,
          response: {},
          checkOne: 'N',
          checkTwo: 'N',
          showContent: false,
          documentLength: false,
        })
      }
    } catch (error) {
      this.setState({
        loading: false,
        response: {},
        showContent: false,
      })
    }
  }

  fetchGetToken = async () => {
    GTMEvents.AhorroYaStep2Btn('continuar')
    const {
      documentType,
      validateOption,
      document,
      validateNumbers,
      inputRefs,
    } = this.state
    if (validateNumbers === 2) {
      inputRefs.map(item => {
        item.value = ''
      })
      this.setState({
        inputRefs: [],
        validateNumbers: 0,
      })
    }
    try {
      this.captcha.current.reset()
      const token = await this.captcha.current.executeAsync()
      const optionValidate =
        validateOption === 1
          ? {
              documentType: documentType,
              documentNumber: document,
              phone: 'ACTIVE',
            }
          : {
              documentType: documentType,
              documentNumber: document,
              email: 'ACTIVE',
            }

      this.setState({ loading: true, showContent: false })
      const response = await ahorroyaApi(
        'POST',
        `${SERVICE_OTP_GENERATION}`,
        optionValidate,
        token
      )
      if (response.code == 'ERROR') {
        this.setState({
          loading: false,
          showContent: true,
          step: 2,
          validateOption: 0,
          restTime: 300,
          emailInvalid: true,
        })
      } else {
        if (validateNumbers === 2) {
          this.setState({
            loading: false,
            responseOtp: response,
            showContent: true,
            validateNumbers: 0,
            restTime: 300,
          })
        } else {
          this.setState({
            loading: false,
            responseOtp: response,
            showContent: true,
            step: 3,
            restTime: 300,
          })
        }
        if (validateNumbers === 0) {
          this.timerToken()
        }
      }
    } catch (error) {
      this.setState({
        loading: false,
        responseOtp: {},
        showContent: false,
      })
    }
  }
  fetchValidateToken = async () => {
    const { response, inputRefs, responseOtp } = this.state
    GTMEvents.AhorroYaRegisterBtn()

    let arrayTemporal = []

    inputRefs.map(item => {
      arrayTemporal.push(item.value)
    })
    const cadena = arrayTemporal.join('')
    this.setState({ tokenValidate: cadena })

    const request = {
      idSolicitud: responseOtp.idSolicitud,
      otp: cadena,
    }

    try {
      this.captcha.current.reset()
      const token = await this.captcha.current.executeAsync()

      this.setState({ loading: true, showContent: false })
      const responseValidateOtp = await ahorroyaApi(
        'POST',
        `${SERVICE_OTP_VALIDATION}`,
        request,
        token
      )

      if (responseValidateOtp.code === '01') {
        this.setState({
          loading: false,
          response: { ...response, code: responseValidateOtp.code },
          newResponseValidate: { ...responseValidateOtp },
          showContent: true,
          validateNumbers: 1,
        })
        this.fetchFinalRegisterAffiliate()
      } else {
        this.setState({
          loading: false,
          showContent: true,
          validateNumbers: 2,
        })
      }
    } catch (error) {
      this.setState({
        loading: false,
        newResponseValidate: {},
        showContent: false,
        withRegister: false,
      })
    }
  }
  fetchFinalRegisterAffiliate = async () => {
    GTMEvents.AhorroYaRegisterBtn()
    const {
      documentType,
      document,
      checkOne,
      checkTwo,
      responseOtp,
      inputRefs,
    } = this.state
    let arrayTemporal = []

    inputRefs.map(item => {
      arrayTemporal.push(item.value)
    })
    const cadena = arrayTemporal.join('')
    try {
      this.captcha.current.reset()
      const token = await this.captcha.current.executeAsync()
      const requestRegister = {
        typeDocument: documentType,
        numberDocument: document,
        termConditions: checkOne,
        authorizedPersonalData: checkTwo,
        otp: cadena,
        idSolicitud: responseOtp.idSolicitud,
      }
      this.setState({ loading: true, showContent: false })
      const responseRegisterSaving = await ahorroyaApi(
        'POST',
        `${SERVICE_AFFILIATE}`,
        requestRegister,
        token
      )

      if (responseRegisterSaving.code === 'NCL-SR-001') {
        this.setState({
          showContent: true,
          withRegister: true,
          loading: false,
          step: 4,
        })
        GTMEvents.AhorroYaIsAfilliateMessageFinishStage()
      } else {
        this.setState({
          loading: false,
          showContent: false,
          validateNumbers: 2,
        })
        GTMEvents.AhorroValidationTokenError(
          'Codigo incorrecto, el codigo de seguridad caduco',
          '3'
        )
      }
    } catch (error) {
      this.setState({
        loading: false,
        newResponseValidate: {},
        showContent: false,
        withRegister: false,
      })
      GTMEvents.AhorroValidationTokenError(
        'Hubo un problema con el envio de correo',
        '3'
      )
    }
  }

  handleCleanState = () => {
    GTMEvents.AhorroYaUnidentifiedBtn()
    this.setState({
      documentType: '00',
      document: '',
      checkOne: 'N',
      checkTwo: 'N',
      response: {},
      showContent: false,
      loading: false,
    })
  }

  renderHasRegister = () => {
    const { response } = this.state
    return (
      <div className="ahorroYa-register__form__screen-has-register">
        <Aprobed className="ahorroYa-register__form__screen-icon-2" />
        <>
          <div className="ahorroYa-register__form__screen-title-2">
            {response.firstName}, Ya eres parte de AhorroYa!
          </div>
          <div className="ahorroYa-register__form__screen-paragraph">
            ¡Empieza a disfrutar de los beneficios en todos nuestros
            establecimientos aliados!
          </div>
        </>
      </div>
    )
  }

  renderLoader = () => {
    const { loading } = this.state
    if (loading) {
      return (
        <div
          className="container-spinner mt-4"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
            borderRadius: '12px',
          }}
        >
          <div className="spinner">
            <SpinnerImage fill="#ED7D2B" />
          </div>
          <p style={{ fontSize: '16px', color: '#FF4f00' }}>
            Te guiamos y acompañamos en tu progreso...
          </p>
        </div>
      )
    }
  }

  renderNoAffiliate = () => {
    GTMEvents.AhorroYaIsNoAfilliateMessage()
    return (
      <>
        <div className="wrapper-image-warning">
          <WarningOtp className="ahorroYa-register__form__screen-icon" />
        </div>
        <h1 className="ahorroYa-register__form__screen-title-3">
          ¡Parece que no eres afiliado PRIMA AFP!
        </h1>
        <div className="ahorroYa-register__form__screen-text">
          <p className="ahorroYa-register__form__screen-paragraph center">
            AhorroYa! es un programa exclusivo para nuestros clientes. Te
            recomendamos <b>revisar nuevamente el número ingresado.</b>
          </p>
        </div>
        <div className="center">
          <p className="mb-2">¿Te equivocaste de documento?</p>
          <div
            className="ahorroYa-register__form__text-button"
            onClick={this.handleCleanState}
          >
            <img
              src={withPrefix('/images/prima-productos/black_arrow_right.svg')}
              alt="Regresar"
            />
            <span>Intentar con otro documento</span>
          </div>
        </div>
      </>
    )
  }

  renderExcess = () => {
    const { response, document, loading } = this.state
    return (
      <>
        <div className="flex justify-center mb-4 mt-2">
          <div className="row-select-input">
            <SelectAhorroYa
              items={[{ name: 'DNI' }, { name: 'CE' }]}
              className="input"
              onChange={this.handleDocumentType}
              disabled={loading}
            />
            <TextInput
              className="input"
              value={document}
              onChange={this.fetchValidationDocument}
              disabled={loading}
            />
          </div>
        </div>
        <p className="ahorroYa-register__form__user-name pb-2 pt-4 b">
          {' '}
          Hola, {response.firstName}, revisa tus datos antes de registrarte{' '}
        </p>
        <div className="ahorroYa-register__form__screen-text">
          <p className="ahorroYa-register__form__text">
            Para que puedas disfrutar por completo de este beneficio y no te
            pierdas sus novedades te recomendamos{' '}
            <a
              href="https://misdatos.prima.com.pe/actualizacion-datos-biometria"
              target="_blank"
            >
              actualizar tus datos de contacto.
            </a>
          </p>
        </div>
        <div className="center pt-4">
          <Btn
            type={'button'}
            disabled={false}
            onClick={this.fetchValidateToken}
            label={'Registrarme al programa'}
            color="orange"
            size="medium"
          />
        </div>
      </>
    )
  }

  renderOkNoData = () => {
    const {
      document,
      response,
      checkOne,
      checkTwo,
      loading,
      documentLength,
      step,
      documentType,
    } = this.state
    return (
      <>
        <div className="wrapper-header-form">
          <p className="ahorroYa-register__form__title_card">
            Si tienes tu <strong>Fondo Obligatorio</strong> o una
            <span> </span>
            <strong>Cuenta de Aportes Voluntarios*</strong>
            en Prima AFP
          </p>
          <p className="ahorroYa-register__form__subTitle flex justify-center mt-2">
            ¡Empieza a ahorrar con tus consumos!
          </p>

          <div className="ahorroYa_form_wrapper_steps">
            <div className="ahorroYa_form_steps">
              {step === 1 ? <IcoStepsOne /> : <IcoStepsCheck />}
              <p
                style={step === 1 ? { color: '#4E5258' } : { color: '#04A6A2' }}
              >
                Ingresa tus datos
              </p>
            </div>
            <div
              className="line_steps"
              style={
                step === 1
                  ? { background: '#c5c7c8' }
                  : { background: '#04A6A2' }
              }
            ></div>
            <div className="ahorroYa_form_steps">
              {step === 1 && <IcoStepsTwoDisabled />}
              {step > 1 && <IcoStepsTwo />}

              <p style={{ color: '#4E5258' }}>Valida tu identidad</p>
            </div>
          </div>
        </div>
        <div className="flex justify-center mb-4 mt-2">
          <div className="row-select-input">
            <SelectAhorroYa
              items={[{ name: 'DNI' }, { name: 'CE' }]}
              className="input"
              onChange={this.handleDocumentType}
              disabled={loading}
              value={documentType}
            />
            <TextInput
              className="input"
              value={document}
              onChange={this.fetchValidationDocument}
              disabled={loading}
            />
          </div>
        </div>
        <p className="ahorroYa-register__form__user-name pb-2 pt-4 b">
          {response.firstName}, necesitamos tus datos de contacto
        </p>
        <div className="ahorroYa-register__form__screen-text">
          <p className="ahorroYa-register__form__text">
            Para que puedas disfrutar por completo de este beneficio y no te
            pierdas sus novedades te recomendamos{' '}
            <a
              href="https://misdatos.prima.com.pe/actualizacion-datos-biometria"
              target="_blank"
            >
              actualizar tus datos de contacto.
            </a>
          </p>
        </div>
      </>
    )
  }

  renderError = () => {
    GTMEvents.AhorroValidationTokenError(
      'no podemos validar tus datos en este momento,  tenemos algunos incovenientes estamos trabajando',
      '1'
    )
    return (
      <>
        <div className="wrapper-image-warning">
          <WarningOtp className="ahorroYa-register__form__screen-icon" />
        </div>
        <h1 className="ahorroYa-register__form__screen-title-3">
          Tenemos algunos inconvenientes
        </h1>
        <div className="ahorroYa-register__form__screen-text mt-4">
          <p className="ahorroYa-register__form__text center">
            <b>
              No podemos validar tus datos en este momento, pero ya estamos
              trabajando para resolverlo.
            </b>{' '}
            <br />
            Por favor, inténtalo de nuevo en unos minutos.
          </p>
        </div>
        <div className="center pt-4">
          <Btn
            type={'button'}
            disabled={false}
            onClick={this.handleCleanState}
            label={'Volver a intentar'}
            color="orange"
            size="medium"
          />
        </div>
      </>
    )
  }

  renderCaptchaError = () => {
    return (
      <>
        <img
          className="ahorroYa-register__form__screen-icon"
          src={withPrefix('/images/prima-productos/warning-icon.svg')}
          alt="No hemos podido identificarte"
        />
        <h1 className="ahorroYa-register__form__screen-title-3">
          Vuelve a cargar la página
        </h1>
        <div className="ahorroYa-register__form__screen-text">
          <p className="ahorroYa-register__form__text center">
            <b>Tuvimos un problema. Para continuar con tu registro,</b> <br />
            necesitamos que vuelvas a cargar la página.
          </p>
        </div>
        <div className="center pt-4">
          <Btn
            type={'button'}
            disabled={false}
            onClick={() => window.location.reload()}
            label={'Volver a intentar'}
            color="orange"
            size="medium"
          />
        </div>
      </>
    )
  }

  handleInputChange = (event, index) => {
    const { value } = event.target
    const { inputRefs } = this.state

    if (event.key === 'Backspace' && event.target.value === '' && index > 0) {
      inputRefs[index - 1].focus()
    }
    if (event.key === 'ArrowLeft' && index > 0 && event.target.length !== '') {
      inputRefs[index - 1].focus()
    } else if (value.length >= 1 && index < inputRefs.length - 1) {
      inputRefs[index + 1].focus()
    }

    let arrayTemporal = []
    inputRefs.map(item => {
      arrayTemporal.push(item.value)
    })
    const cadena = arrayTemporal.join('')
    this.setState({ tokenValidate: cadena })
  }

  validateToken = () => {
    const { inputRefs } = this.state
    let arrayTemporal = []
    inputRefs.map(item => {
      arrayTemporal.push(item.value)
    })
    const cadena = arrayTemporal.join('')
    this.setState({ tokenValidate: cadena })
  }

  selectOptionValidate = option => {
    this.setState({ validateOption: option })
  }
  timerToken = () => {
    this.timerInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.restTime <= 0) {
          clearInterval(this.timerInterval)
          return { restTime: 0 }
        }
        return { restTime: prevState.restTime - 1 }
      })
    }, 1000)
  }
  formatTime(seconds) {
    const minutes = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`
  }
  step1 = () => {
    const { document, response, checkOne, loading, documentLength } = this.state
    return (
      <>
        <div className="wrapper_container_step">
          <p className="ahorroYa-register__form__document_title">
            Ingresa tu documento de identidad
          </p>
          <div className="flex mb-3">
            <div className="row-select-input">
              <SelectAhorroYa
                items={[{ name: 'DNI' }, { name: 'CE' }]}
                className="input"
                onChange={this.handleDocumentType}
                disabled={loading}
              />
              <TextInput
                className="input"
                value={document}
                onChange={this.fetchValidationDocument}
                disabled={loading}
              />
            </div>
          </div>
          <div className="wrapper_validate_info">
            <p className="ahorroYa-register__form__validate_title">
              Valida tus datos de contacto
            </p>
            {response.firstName && (
              <a
                className="ahorroYa-register__form__update_data"
                href="https://misdatos.prima.com.pe/actualizacion-datos-biometria"
                target="_blank"
                onClick={() => {
                  GTMEvents.AhorroYaStep1Btn('¿Quieres actualizar tus datos?')
                }}
              >
                ¿Quieres actualizar tus datos?
              </a>
            )}
          </div>
          <div
            className={`ahorroYa-register__form__inputs flex justify-between`}
          >
            <div className="wrapper_inputs_form">
              <p>Correo electrónico</p>
              <Input
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                disabled
                placeholder="Ejem. correo@dominio..."
                name="email"
                value={response.email ? response.email : ''}
              />
            </div>
            <div className="wrapper_inputs_form">
              <p>Celular</p>
              <Input
                disabled
                placeholder="+51 Ejem.  980 998 099"
                name="cellPhone"
                value={response.cellPhone ? '+51 ' + response.cellPhone : ''}
              />
            </div>
          </div>
          <div className="wrapper_validate_info mobile_update_wrapper">
            {response.firstName && (
              <a
                className="ahorroYa-register__form__update_data update_data_mobile"
                href="https://misdatos.prima.com.pe/actualizacion-datos-biometria"
                target="_blank"
                onClick={() => {
                  GTMEvents.AhorroYaStep1Btn('¿Quieres actualizar tus datos?')
                }}
              >
                ¿Quieres actualizar tus datos?
              </a>
            )}
          </div>
          <div
            className={`${
              checkOne === 'S' ? 'ahorroYa-checkbox-checked' : ''
            } ahorroYa-checkbox-form  flex mb-2 pt-1`}
          >
            <RadCheck
              name="checkOne"
              type="checkbox"
              check={checkOne === 'S' ? true : false}
              val={checkOne}
              onChange={this.handleCheckOne}
            />{' '}
            <span className="ml-1 ahorroYa-register__form__title">
              Acepto los{' '}
              <a
                href={withPrefix('/aliados-comerciales/terminos-y-condiciones')}
                target="_blank"
              >
                términos y condiciones
              </a>{' '}
              y declaro haber leído la Política de Privacidad de Prima AFP.
            </span>
          </div>
          <div className="mt-4 center">
            <div>
              <Btn
                type={'button'}
                disabled={!documentLength || checkOne !== 'S'}
                onClick={() => {
                  GTMEvents.AhorroYaStep1Btn('Continuar')
                  this.setState({ step: 2 })
                }}
                label={'Continuar'}
                color="orange"
                size="medium"
              />
            </div>
          </div>
        </div>
      </>
    )
  }
  step2 = () => {
    const { response, validateOption, emailInvalid, emailNull } = this.state
    return (
      <>
        <div className="wrapper_container_step">
          <p className="title_step2_otp">Elige como validar tu identidad</p>
          <div className="wrapper_validate_opions">
            <div
              style={
                response.cellPhone === null
                  ? { border: '1.5px solid #e7e7e8', pointerEvents: 'none' }
                  : validateOption === 1
                  ? { border: '1.5px solid #FF4F00' }
                  : { border: '1.5px solid #e7e7e8' }
              }
              onClick={() => {
                GTMEvents.AhorroYaStep2Btn('telefono')
                this.setState({ validateOption: 1 })
              }}
              className={`${
                response.cellPhone === '' ? 'option_step2_disabled' : ''
              } option_step2 `}
            >
              <IconEmailOption />
              <div className="wrapper_texts_option">
                {response.cellPhone ? (
                  <h1>+51 {response.cellPhone}</h1>
                ) : (
                  <h1>No cuenta con numero registrado</h1>
                )}
                <p>Solo para números peruanos.</p>
              </div>
              <div
                className={
                  validateOption === 1
                    ? 'optionValidate'
                    : 'optionValidateNoMark'
                }
              ></div>
            </div>
            <div
              style={
                emailNull || emailInvalid
                  ? { border: '1.5px solid #e7e7e8', pointerEvents: 'none' }
                  : validateOption === 2
                  ? { border: '1.5px solid #FF4F00' }
                  : { border: '1.5px solid #e7e7e8' }
              }
              onClick={() => {
                GTMEvents.AhorroYaStep2Btn('mail')
                this.setState({ validateOption: 2 })
              }}
              className={`${
                emailNull || emailInvalid ? 'option_step2_disabled' : ''
              } option_step2 `}
            >
              <IconSmsOption />
              <div className="wrapper_texts_option">
                <h1>{response.email}</h1>
                {emailNull || emailInvalid ? (
                  <p className="email_invalid">Tu correo no es válido</p>
                ) : (
                  <p>Correo personal de preferencia.</p>
                )}
              </div>
              {emailNull || emailInvalid ? (
                <div className="optionInvalidEmail"></div>
              ) : (
                <div
                  className={
                    validateOption === 2
                      ? 'optionValidate'
                      : 'optionValidateNoMark'
                  }
                ></div>
              )}
            </div>
            {emailNull ||
              (emailInvalid && (
                <p className="update_data_step2">
                  {' '}
                  Elige otra opción o{' '}
                  <span
                    onClick={() => {
                      GTMEvents.AhorroYaStep1Btn(
                        '¿Quieres actualizar tus datos?'
                      )
                      window.open(
                        'https://misdatos.prima.com.pe/actualizacion-datos-biometria',
                        'security',
                        'noopener'
                      )
                    }}
                  >
                    {' '}
                    Actualiza tus datos.
                  </span>
                </p>
              ))}
          </div>
          <div className="mt-4 center">
            <div>
              <Btn
                type={'button'}
                disabled={validateOption === 0 ? true : false}
                onClick={this.fetchGetToken}
                label={'Continuar'}
                color="orange"
                size="medium"
              />
            </div>
          </div>
        </div>
      </>
    )
  }
  step3 = () => {
    const {
      response,
      inputRefs,
      validateOption,
      restTime,
      validateNumbers,
    } = this.state
    return (
      <>
        <form className="wrapper_container_step">
          <p className="title_step2_otp">
            Enviamos el código de verificación al{' '}
            {validateOption === 1 ? 'número:' : 'correo electrónico:'}
          </p>
          <p className="text_type_option_validate">
            {validateOption === 1
              ? '+51 ' + response.cellPhone
              : response.email}
          </p>
          <div className="wrapper_inputs">
            <div
              className="wrapper_single_token"
              style={
                validateNumbers == 0
                  ? { border: '1.5px solid #E7E7E8 ' }
                  : validateNumbers == 1
                  ? { border: '1.5px solid #00CCCC ' }
                  : { border: '1.5px solid #FF0000' }
              }
            >
              <input
                type="tel"
                ref={input => (inputRefs[0] = input)}
                onKeyUp={event => this.handleInputChange(event, 0)}
                maxLength="1"
                id="0"
                autoFocus
                aria-invalid="false"
                pattern="[0-9]*"
                inputmode="numeric"
              />
            </div>
            <div
              className="wrapper_single_token"
              style={
                validateNumbers == 0
                  ? { border: '1.5px solid #E7E7E8 ' }
                  : validateNumbers == 1
                  ? { border: '1.5px solid #00CCCC ' }
                  : { border: '1.5px solid #FF0000' }
              }
            >
              <input
                type="tel"
                ref={input => (inputRefs[1] = input)}
                onKeyUp={event => this.handleInputChange(event, 1)}
                maxLength="1"
                id="1"
                aria-invalid="false"
                pattern="[0-9]*"
                inputmode="numeric"
              />
            </div>
            <div
              className="wrapper_single_token"
              style={
                validateNumbers == 0
                  ? { border: '1.5px solid #E7E7E8 ' }
                  : validateNumbers == 1
                  ? { border: '1.5px solid #00CCCC ' }
                  : { border: '1.5px solid #FF0000' }
              }
            >
              <input
                type="tel"
                ref={input => (inputRefs[2] = input)}
                onKeyUp={event => this.handleInputChange(event, 2)}
                maxLength="1"
                id="2"
                aria-invalid="false"
                pattern="[0-9]*"
                inputmode="numeric"
              />
            </div>
            <div
              className="wrapper_single_token"
              style={
                validateNumbers == 0
                  ? { border: '1.5px solid #E7E7E8 ' }
                  : validateNumbers == 1
                  ? { border: '1.5px solid #00CCCC ' }
                  : { border: '1.5px solid #FF0000' }
              }
            >
              <input
                type="tel"
                ref={input => (inputRefs[3] = input)}
                onKeyUp={event => this.handleInputChange(event, 3)}
                maxLength="1"
                id="3"
                aria-invalid="false"
                pattern="[0-9]*"
                inputmode="numeric"
              />
            </div>
            <div
              className="wrapper_single_token"
              style={
                validateNumbers == 0
                  ? { border: '1.5px solid #E7E7E8 ' }
                  : validateNumbers == 1
                  ? { border: '1.5px solid #00CCCC ' }
                  : { border: '1.5px solid #FF0000' }
              }
            >
              <input
                type="tel"
                ref={input => (inputRefs[4] = input)}
                onKeyUp={event => this.handleInputChange(event, 4)}
                maxLength="1"
                id="4"
                aria-invalid="false"
                pattern="[0-9]*"
                inputmode="numeric"
              />
            </div>
            <div
              className="wrapper_single_token"
              style={
                validateNumbers == 0
                  ? { border: '1.5px solid #E7E7E8 ' }
                  : validateNumbers == 1
                  ? { border: '1.5px solid #00CCCC ' }
                  : { border: '1.5px solid #FF0000' }
              }
            >
              <input
                type="tel"
                ref={input => (inputRefs[5] = input)}
                onKeyUp={event => this.handleInputChange(event, 5)}
                maxLength="1"
                id="5"
                aria-invalid="false"
                pattern="[0-9]*"
                inputmode="numeric"
              />
            </div>
          </div>
          <p
            className="text_title_code_validate"
            style={
              validateNumbers == 1 ? { color: '#04A6A2' } : { color: '#FF0000' }
            }
          >
            {validateNumbers == 1 && (
              <p className="message_token">
                <ValidToken /> Código válido
              </p>
            )}
            {validateNumbers == 2 && (
              <p className="message_token">
                <NoValidToken /> Código incorrecto
              </p>
            )}
          </p>
          {validateNumbers === 0 && (
            <p className="text_information_time_expired">
              <Clock /> El código vencerá en{' '}
              <strong>
                {' '}
                {this.formatTime(restTime)}{' '}
                {restTime < 60 ? 'segundos' : 'minutos'}{' '}
              </strong>
            </p>
          )}
          {restTime == 0 &&
            GTMEvents.AhorroValidationTokenError(
              'El codigo de seguridad caduco',
              '3'
            )}
          <div className="mt-4 center">
            <div className="wrapper_button_ahorroya">
              <Btn
                type={'button'}
                label={
                  validateNumbers === 0
                    ? 'Validar código'
                    : validateNumbers === 1
                    ? 'Finalizar registro '
                    : 'Reenviar código'
                }
                color="orange"
                size="medium"
                onClick={
                  validateNumbers === 0
                    ? this.fetchFinalRegisterAffiliate
                    : this.fetchGetToken
                }
              />
            </div>
          </div>
        </form>
      </>
    )
  }
  renderInit = () => {
    const { step } = this.state
    return (
      <>
        {step !== 4 && <HeadersSteps step={step} />}
        {step === 1 && this.step1()}
        {step === 2 && this.step2()}
        {step === 3 && this.step3()}
        {step === 4 && <Step4 />}
      </>
    )
  }

  renderScreens = (code, response) => {
    switch (code) {
      case 'NO_CLIENT':
        return this.renderNoAffiliate()
      case 'NO_APV':
        return this.renderExcess()
      case 'CLIENT':
        return this.renderHasRegister()
      case '01':
        return this.renderHasRegister()
      case 'RECAPTCHA_ERROR':
        return this.renderCaptchaError()
      case '':
        return this.renderInit()
      case 'NO_REGISTERED':
        return response.email === null && response.cellPhone === null
          ? this.renderOkNoData()
          : this.renderInit()
      case 'ERROR':
        return this.renderError()
      default:
        return this.renderInit()
    }
  }

  render() {
    const { response } = this.state
    const code = CODES_RESPONSE[response.code]
    return (
      <div className="ahorroYa-register__form">
        {this.renderScreens(code, response)}
        {this.renderLoader()}
        {isBrowser() && (
          <ReCAPTCHA
            sitekey={RECAPTCHA_AHORROYA_INVISIBLE_KEY}
            size="invisible"
            badge="bottomleft"
            ref={this.captcha}
            onChange={this.onVerify}
            onExpired={this.onExpired}
          />
        )}
      </div>
    )
  }
}
export default RegistrateAqui
